module.exports = __webpack_public_path__ + "img/sngls.b27df4f2.svg";